import { useState, useEffect } from 'react';
import { fetchTemplates } from '../../../services/b2b-social-apiServices';
import { showNotification } from '../../b2b-common/Notification';
import { useContentContext } from '../../layout/Layout';
import { useLoginContext } from '../../../App';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const useTemplates = () => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-social');

    const [templates, setTemplates] = useState(null);
    const [fetchingTemplates, setFetchingTemplates] = useState(false);

    const getTemplates = async () => {
        try {
            setFetchingTemplates(true);
            const fetchedTemplates = await fetchTemplates(loginData.accessToken);
            setTemplates(fetchedTemplates);
        } catch (error) {
            console.error('Error fetching templates: ' + error.message);
            showNotification(setNotification, t('Error fetching templates: ') + error.message, 'error', 5000);
        } finally {
            setFetchingTemplates(false);
        }
    };

    useEffect(() => {
        getTemplates();
    }, [loginData]);

    return { templates, setTemplates, fetchingTemplates, getTemplates };
};

export default useTemplates;